var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Group 19684",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14661",
  transform: "translate(3.087 2.765)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.633,
  cy: 7.633,
  r: 7.633,
  "data-name": "Ellipse 1550"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.674 13.362 4.681 4.636",
  "data-name": "Line 1223"
}))));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "static/media/search.5788258827386aafff7ef910a9e2ff94.svg";